module.exports = __webpack_public_path__ + "img/CAL-UHF-Zubehörkoffer_white_shadow_Var3.54dad6f4.webp";